<template>
  <el-card
    class="expert-card"
    :body-style="{ height: '100%', 'background-color': 'var(--nxt-color-lightest-blue)'}">
    <div class="expert-card__body">
      <div>
        <img
          class="expert-card__body__image"
          :src="image"
          @error="setFallback" />
      </div>
      <p
        class="expert-card__body__text to-upper-case"
        v-html="$t('home.descriptifsCards.yourExpert', { expert: expertName })">
      </p>
    </div>
  </el-card>
</template>

<script>
import { mapState } from 'pinia';
import { useDemandStore } from '@/stores';
import blankUser from '@/assets/img/blank-user.png';

export default {
  name: 'expertCard',
  data() {
    return {
      fallback: false,
    };
  },
  computed: {
    ...mapState(useDemandStore, ['demand']),
    expertName() {
      if (this.expert) {
        return this.expert.first_name;
      }
      return this.$t('home.descriptifsCards.noExpert');
    },
    expert() {
      if (this.demand.assigned_user) {
        return this.demand.assigned_user;
      }
      if (this.demand.meeting && this.demand.meeting.expert) {
        return this.demand.meeting.expert;
      }
      return null;
    },
    image() {
      if (!this.expert) {
        return blankUser;
      }
      return this.fallback
        ? blankUser
        : `https://backend.nextories.com/images/users/${this.expert.id}.png`;
    },
  },
  methods: {
    setFallback() {
      this.fallback = true;
    },
  },
};
</script>

<style scoped lang="scss">
.expert-card {
  margin-bottom: 20px;
  border-radius: 0;
  border: none;
  @include breakpoint(tablet) {
    border-radius: 4px;
    margin: 0;
  }
  &__body {
    position: relative;
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-bottom: 0;
    font-size: 18px;
    height: 100%;
    &__image {
      border-radius: 50%;
      width: 100px;
    }
    &__text {
      margin: 20px 0;
      font-size: 20px;
      flex: 1 1;
    }
  }
}
</style>
